import React, { useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import moment from 'moment';

import LocalActivity from '@material-ui/icons/LocalActivity';

import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import { showCoupon, editCoupon, createCoupon } from '~/config/routes';
import { AbilityContext } from '~/contexts/Can';

import CouponContext from './context';

function CouponList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(CouponContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`coupon.attributes.${attr}`);

  function handleDeletionModal(id, title) {
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete() {
    try {
      await Request.del(`/admin/coupon/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch (e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = ['search', 'filter'];

  if (ability.can('new', 'Coupon')) {
    actions.push('new');
  }
  if (ability.can('edit', 'Coupon')) {
    actions.push('edit');
  }
  if (ability.can('delete', 'Coupon')) {
    actions.push('del');
  }
  if (ability.can('show', 'Coupon')) {
    actions.push('show');
  }

  function ParseFloat(str, val) {
    str = str.toFixed(2);
    str = str.toString();
    str = str.slice(0, (str.indexOf('.')) + val + 1); 
    return Number(str);   
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createCoupon}
        routeToEdit={editCoupon}
        routeToShow={showCoupon}
        listEl={listEl}
        path={'/admin/coupon/'}
        actions={actions}
        paperProps={{
          Icon: LocalActivity,
          iconColor: 'blue',
          title: t('coupon.defPlural'),
        }}
        columns={[
          { 
            title: trAttr('name'), 
            field: 'name', 
            type: 'string' 
          },
          { 
            title: trAttr('promotion_type'), 
            field: 'promotion_type', 
            type: 'string' 
          },
          { 
            title: trAttr('discount_value'), 
            field: 'discount_value', 
            type: 'string',
            // eslint-disable-next-line react/display-name
            render: rowData => <label>{`${rowData.discount_type === 2 ? `${ParseFloat(rowData.discount_value, 2).toFixed(2)}%` : `R$ ${ParseFloat(rowData.discount_value, 2).toFixed(2)}`}`}</label>
          },
          {
            title: trAttr('start_date'),
            field: 'start_date',
            type: 'datetime',
          },
          {
            title: trAttr('expires_at'),
            field: 'expires_at',
            type: 'datetime',
          },
          { 
            title: trAttr('user_limit'), 
            field: 'user_limit', 
            type: 'string' 
          },
          { 
            title: trAttr('times_used'), 
            field: 'times_used', 
            type: 'string' 
          },
        ]}
        context={CouponContext}
        recordMap={(record) => ({
          ...record,
          start_date: record.start_date
            ? moment(record.start_date).format('DD/MM/YYYY HH:mm')
            : null,
          expires_at: record.expires_at
            ? moment(record.expires_at).format('DD/MM/YYYY HH:mm')
            : null        
          })}
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(CouponList);
